module.exports = __webpack_public_path__ + "static/media/fvs_valve1_8.6cca484e.jpg";